// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider {
  width: 100%;
  height: 1px;
  border-top: solid 1px var(--white-color-dark);
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Divider.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;EACA,6CAAA;EACA,sBAAA;AACF","sourcesContent":[".divider {\r\n  width: 100%;\r\n  height: 1px;\r\n  border-top: solid 1px var(--white-color-dark);\r\n  box-sizing: border-box;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
